import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { formatDistance } from "@src/appV2/redesign/Workplace/useDistanceToWorkplace";

import { Button } from "../../../components/Button";
import { DialogFooter } from "../../../components/DialogFooter";
import { type FacilityWithDistance } from "../../data/schemas";

interface InitialQuestionSheetProps {
  facility: FacilityWithDistance;
  onYes: () => void;
  onNo: () => void;
}

export function InitialQuestionSheet({ facility, onYes, onNo }: InitialQuestionSheetProps) {
  return (
    <Stack spacing={8}>
      <Stack spacing={3} alignItems="center">
        <Text semibold variant="h3" sx={{ textAlign: "center" }}>
          {facility.name}
        </Text>
        <Stack spacing={1} alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <CbhIcon type="map-pin" size="small" color={(theme) => theme.palette.text.secondary} />
            <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
              {facility.address}
            </Text>
          </Stack>
          <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
            {facility.city}, {facility.state} {facility.zipCode}
          </Text>
          {facility.distance !== undefined && (
            <Text variant="body1" color={(theme) => theme.palette.primary.main}>
              {formatDistance(Number(facility.distance))} away
            </Text>
          )}
        </Stack>
      </Stack>

      <Stack spacing={2} alignItems="center">
        <Text semibold variant="h4" sx={{ textAlign: "center" }}>
          Have you worked at this facility before?
        </Text>
        <Text
          variant="body1"
          color={(theme) => theme.palette.text.secondary}
          sx={{ textAlign: "center" }}
        >
          This helps us prioritize your interest when the facility joins Clipboard.
        </Text>
      </Stack>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onYes}>
          Yes, I have worked here before
        </Button>
        <Button fullWidth variant="outlined" size="large" onClick={onNo}>
          No, I have not worked here before
        </Button>
      </DialogFooter>
    </Stack>
  );
}
